<footer class="unauth-footer">
    <div class="d-flex justify-content-end flex-row">
        <div class="navigation">
            <div class="navitems">
                @if (appConfig.languageSwitcher) {
                    @for (language of availableLanguages; track language.code) {
                        <div class="navitem">
                            <button
                                type="button"
                                class="has-pointer"
                                (click)="changeLanguage(language.code)">
                                {{ language.label }}
                            </button>
                        </div>
                    }
                }
                <div class="navitems">
                    @for (footerLink of footerLinks; track footerLink) {
                        <div class="navitem">
                            <a
                                [href]="footerLink.link"
                                target="_blank"
                                >{{ footerLink.translationKey | translate }}</a
                            >
                        </div>
                    }
                    <div class="navitem">
                        <a
                            class="has-pointer"
                            routerLink="/licenses"
                            >{{ 'GENERAL.LICENSES' | translate }}</a
                        >
                    </div>
                    <div
                        class="navitem"
                        [matTooltip]="versionString()"
                        matTooltipClass="tw-whitespace-pre-line tw-max-w-[320px]">
                        <span>{{ 'GENERAL.VERSION' | translate }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
